var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "main page home" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "home__layout" }, [
        _c(
          "div",
          { staticClass: "home__main" },
          [
            _c("HomeBanner", {
              attrs: {
                title: _vm.bannerData.title,
                subtitle: _vm.bannerData.subtitle,
                description: _vm.bannerData.description,
                label: _vm.bannerData.label,
                "cta-text": _vm.bannerData.ctaText,
                "cta-url": _vm.bannerData.ctaUrl,
                "background-image": _vm.bannerData.backgroundImage,
                "event-date": _vm.bannerData.eventDate,
              },
            }),
            _vm._v(" "),
            _vm.activeChips.length && !_vm.filtersOpen
              ? _c("div", { staticClass: "active-filters" }, [
                  _c(
                    "div",
                    { staticClass: "active-filters__chips" },
                    _vm._l(_vm.activeChips, function (chip) {
                      return _c(
                        "span",
                        {
                          key: `${chip.category}-${chip.id}`,
                          staticClass: "active-filters__chip",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(chip.label) +
                              "\n              "
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "active-filters__chip-x",
                              on: {
                                click: function ($event) {
                                  return _vm.removeFilter(chip)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "10",
                                    height: "10",
                                    viewBox: "0 0 10 10",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1 1l8 8M9 1l-8 8",
                                      stroke: "currentColor",
                                      "stroke-width": "1.5",
                                      "stroke-linecap": "round",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "active-filters__clear",
                      on: { click: _vm.clearAllFilters },
                    },
                    [_vm._v("Clear all")]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("FeedFilters", {
              attrs: {
                open: _vm.filtersOpen,
                "filter-data": _vm.filterData,
                "initial-selections": _vm.storedSelections,
                "initial-labels": _vm.storedSelectionLabels,
                "filters-loading": _vm.filtersRefreshing,
              },
              on: {
                close: function ($event) {
                  _vm.filtersOpen = false
                },
                apply: _vm.onFiltersApply,
                "filter-changed": _vm.onFilterSelectionChanged,
              },
            }),
            _vm._v(" "),
            _c("HomeFeed", {
              attrs: {
                articles: _vm.feedArticles,
                tabs: _vm.feedTabs,
                loading: _vm.feedLoading,
                "has-more": _vm.hasMoreArticles,
              },
              on: {
                "tab-change": _vm.onTabChange,
                "load-more": _vm.loadMoreArticles,
                "open-filters": _vm.openFilters,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "home__sidebar" },
          [
            _c("AlertTriage", {
              on: { dismiss: _vm.onAlertDismiss, action: _vm.onAlertAction },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }